import { gql } from '@apollo/client'

export const GET_THREADS_QUERY = gql`
  query GetThreads($workspaceId: String!) {
    threadsForUser(workspaceId: $workspaceId) {
      id
      workspaceId
      title
      avatarId
      avatarType
    }
  }
`

export const GET_THREADS_FOR_OBJECT_QUERY = gql`
  query GetThreadsForObject(
    $objectType: String!
    $objectId: String!
    $workspaceId: String!
  ) {
    threadsForObjectForUser(
      objectType: $objectType
      objectId: $objectId
      workspaceId: $workspaceId
    ) {
      id
      workspaceId
      title
      avatarId
      avatarType
    }
  }
`

export const GET_THREAD_QUERY = gql`
  query GetThread($id: String!, $workspaceId: String!) {
    thread(id: $id, workspaceId: $workspaceId) {
      id
      workspaceId
      title
      avatarId
      avatarType
      messages {
        id
        content
        type
        userId
        createdAt
        pages {
          id
          title
          contentHtml
          contentJson
          createdAt
          updatedAt
          ownerEmail
          crmObjects {
            objectId
            objectType
          }
          actionIds
          templateType
        }
        links {
          href
          text
        }
      }
      contextObjects {
        objectId
        objectType
      }
    }
  }
`

export const GET_CONTEXT_FOR_THREAD = gql`
  query ContextForThread($threadId: String!, $workspaceId: String!) {
    contextForThread(threadId: $threadId, workspaceId: $workspaceId) {
      contextString
      tokenCount
    }
  }
`

export const GET_THREAD_WITH_CONTEXT = gql`
  query ThreadWithContext($threadId: String!, $workspaceId: String!) {
    threadWithContext(threadId: $threadId, workspaceId: $workspaceId) {
      thread {
        id
        workspaceId
        title
        avatarId
        avatarType
        dismissedObjects {
          objectId
          objectType
        }
        messages {
          id
          content
          type
          userId
          createdAt
          pages {
            id
            title
            contentHtml
            contentJson
            createdAt
            updatedAt
            ownerEmail
            crmObjects {
              objectId
              objectType
            }
            actionIds
            templateType
          }
          links {
            href
            text
          }
        }
        contextObjects {
          objectId
          objectType
        }
      }
      context {
        contextString
        tokenCount
      }
    }
  }
`

export const GET_ORGANIZATION_COLOR = gql`
  query GetOrganizationColor($domain: String!, $workspaceId: String!) {
    workspaceOrganization(domain: $domain, workspaceId: $workspaceId) {
      colors {
        colorVibrant
      }
    }
  }
`

export const GET_TIPTAP_JWT = gql`
  query GetTiptapJwt($timestamp: Int!) {
    getTiptapJwt(timestamp: $timestamp)
  }
`
